export const CHECKOUT_URL = 'https://usaebookpoint.shop/cart/54966664429940:1'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/rXcLGZuZHm7dbAsNW8NkKn/ChatGPT_Image_Jul_21,_2026,_11_47_19_PM.png'

export const COURT_BG =
  'https://cdn.magicpatterns.com/patterns/generated-images/e0512e93-39b6-4647-bd88-00a517a830c3.jpg'

export interface CoreTool {
  emoji: string
  title: string
  format: string
  body: string
  image?: string
}

export const CORE_TOOLS: CoreTool[] = [
  {
    emoji: '🏓',
    title: 'Class Generator',
    format: 'Excel',
    body: 'A 49-drill bank plus a live generator that builds a complete class from your level, duration, and focus.',
    image:
      'https://cdn.magicpatterns.com/uploads/sLU6tomF9Zfja8uQjFqLCQ/ChatGPT_Image_Jul_21,_2026,_06_45_54_PM.png',
  },
  {
    emoji: '🧮',
    title: 'Pricing Calculator',
    format: 'Excel',
    body: 'Set your costs once, get suggested rates, and simulate monthly income against your actual roster and goals.',
    image:
      'https://cdn.magicpatterns.com/uploads/hn27Hzjgkv43wDS4xN5mpr/ChatGPT_Image_Jul_21,_2026,_06_46_00_PM.png',
  },
  {
    emoji: '📇',
    title: 'Student CRM',
    format: 'Excel',
    body: 'A live dashboard for students, payments, follow-ups, and at-risk retention alerts.',
    image:
      'https://cdn.magicpatterns.com/uploads/mNZNRBbFLrB3JALjRGimDc/ChatGPT_Image_Jul_21,_2026,_06_46_17_PM.png',
  },
  {
    emoji: '⚖️',
    title: 'Legal Kit',
    format: 'Word',
    body: 'Ready-to-use waiver, teaching-services agreement, and cancellation-policy templates.',
    image:
      'https://cdn.magicpatterns.com/uploads/nfR3u6kRiy3pzrYbMjGk2x/ChatGPT_Image_Jul_21,_2026,_06_46_21_PM.png',
  },
  {
    emoji: '💌',
    title: 'Message Kit',
    format: 'Word',
    body: '25+ ready-to-send messages for every key student touchpoint, from first contact to renewal.',
    image:
      'https://cdn.magicpatterns.com/uploads/kw8VWbh6TpuFRPAYiSCpMc/ChatGPT_Image_Jul_21,_2026,_06_46_24_PM.png',
  },
  {
    emoji: '📚',
    title: 'Pre-Built Class Library',
    format: 'Word',
    body: '40 mapped-out classes, clinics, bootcamp programs, and an editable annual programming calendar.',
    image:
      'https://cdn.magicpatterns.com/uploads/5kQXBwKdk6JNkqp9z5vnmL/ChatGPT_Image_Jul_21,_2026,_06_46_29_PM.png',
  },
]

export const PAIN_POINTS: string[] = [
  "Sunday's spent planning classes.",
  'Rewriting the same drills over and over.',
  'Forgetting who still has sessions left.',
  'Answering the same student questions every week.',
  'Wondering why some students suddenly stop booking.',
  'Trying to coach... while also running an entire business.',
]

export interface Review {
  name: string
  city: string
  text: string
}

export const REVIEWS: Review[] = [
  {
    name: 'Mike Sullivan',
    city: 'Naples, FL',
    text: "I've been coaching pickleball for 3 years and this is the first resource that actually treats it like a real business. The pricing calculator alone paid for itself in one week.",
  },
  {
    name: 'Debbie Harmon',
    city: 'Scottsdale, AZ',
    text: 'The pre-built classes are a lifesaver. I coach a lot of 55+ players and the senior routines are gold. I stopped improvising and my students noticed the difference immediately.',
  },
  {
    name: 'Carlos Mendez',
    city: 'Austin, TX',
    text: "Went from 12 to 30 weekly students in two months using the referral system and the message templates. Wish I'd had this when I started.",
  },
  {
    name: 'Karen Whitfield',
    city: 'Charlotte, NC',
    text: "The CRM finally gave me control over my roster. I can see who's about to churn and reach out before I lose them. Absolute game changer for retention.",
  },
]

export interface Testimonial {
  name: string
  age: number
  city: string
  text: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Greg Patterson',
    age: 52,
    city: 'Tampa, FL',
    text: "Best $25 I've spent on my coaching career. Everything is done-for-you.",
  },
  {
    name: 'Linda Cortez',
    age: 47,
    city: 'Phoenix, AZ',
    text: 'I raised my rates 40% and nobody blinked. The value framing scripts work.',
  },
  {
    name: 'Tom Whitaker',
    age: 58,
    city: 'Denver, CO',
    text: 'Delivered instantly, opened it on my phone at the court. Super practical.',
  },
  {
    name: 'Sandra Klein',
    age: 44,
    city: 'San Diego, CA',
    text: 'The Excel tools are ridiculously good. My monthly income is finally predictable.',
  },
  {
    name: 'Rick Donovan',
    age: 55,
    city: 'Columbus, OH',
    text: 'Went full-time thanks to the business volume. Clear, no fluff, all action.',
  },
]

export interface Objection {
  q: string
  a: string
}

export const OBJECTIONS: Objection[] = [
  {
    q: "I'm just starting out — is this too advanced for me?",
    a: 'Not at all. The kit starts from the absolute fundamentals and gives you ready-to-run beginner classes, so you can teach with confidence from day one, even without years of experience.',
  },
  {
    q: 'Is it really 100% digital? When do I get it?',
    a: "Yes — it's fully digital (PDF + editable Excel/Word files) and delivered instantly to your email right after purchase. No shipping, no waiting.",
  },
  {
    q: '$25 seems too cheap. Is it actually complete?',
    a: "It includes six ready-to-use coaching systems: planning, pricing, student tracking, legal templates, messages, and a complete class library. The $25 launch price is an intro offer — the regular price is $75.",
  },
  {
    q: "I'm not tech-savvy. Can I use the Excel and Word tools?",
    a: 'Absolutely. Everything is pre-built — you just fill in a few cells or edit text. If you can open a spreadsheet or a document, you can use every tool in the kit.',
  },
  {
    q: "What if it's not for me?",
    a: 'Reach out any time at EbookDreamShop@gmail.com and our support team will personally help you get the most out of the kit.',
  },
]

export const BUYER_NAMES = [
  'James',
  'Robert',
  'Michael',
  'David',
  'William',
  'Patricia',
  'Jennifer',
  'Linda',
  'Barbara',
  'Susan',
  'Karen',
  'Nancy',
  'Greg',
  'Tom',
  'Rick',
  'Sandra',
  'Debbie',
  'Mike',
  'Carlos',
  'Karen',
]

export const BUYER_CITIES = [
  'Tampa, FL',
  'Phoenix, AZ',
  'Denver, CO',
  'San Diego, CA',
  'Columbus, OH',
  'Austin, TX',
  'Naples, FL',
  'Scottsdale, AZ',
  'Charlotte, NC',
  'Dallas, TX',
  'Seattle, WA',
  'Portland, OR',
  'Nashville, TN',
  'Atlanta, GA',
  'Boston, MA',
  'Sacramento, CA',
  'Orlando, FL',
  'Las Vegas, NV',
  'Raleigh, NC',
  'Kansas City, MO',
]
